export default "__VITE_ASSET__ZiEIW4rq__"